import React, { useEffect, useState } from 'react';
import { GroupInput } from '../GroupInput/GroupInput';
import './AgeSelector.scss';

const styles = require('b_')
    .with('age-selector');
const inputStyles = require('b_')
    .with('input');

const createAgeMetadata = () => {
    const res = [
        {
            id: -1,
            name: ' ',
        },
    ];
    for (let i = 0; i < 18; i += 1) {
        res.push({
            id: i.toString(),
            name: `${i}`,
        });
    }
    return res;
};

const ageMetadata = createAgeMetadata();

export const AgeSelector = ({
    age,
    onChange,
    label,
}) => {
    const [ selectedAge, setSelectedAge ] = useState(age);

    useEffect(() => {
        if (age !== selectedAge) {
            setSelectedAge(age ?? -1);
        }
    }, [age]);

    return (
        <div className={styles()}>
            {!!label && <div className={`${styles('label')} ${inputStyles('label')}`}>{label}</div>}
            <div className={styles('checkbox')}>
                <GroupInput
                    type="selector"
                    typeInput="button"
                    onChange={(v) => {
                        setSelectedAge(v);
                        onChange && onChange(v);
                    }}
                    metaData={ageMetadata}
                    id="childrenAge"
                    value={selectedAge}
                    padding={8}
                    pre
                />
            </div>
        </div>
    );
};
